"use strict";
var EmailTemplateBlock_1;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../index");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const ads_1 = require("../ads");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const ContentFeed_1 = require("../content/ContentFeed");
const Context_1 = require("../core/Context");
const Email_1 = require("./Email");
const EmailTemplateVersion_1 = require("./EmailTemplateVersion");
const ContentConversion_1 = require("../converter/ContentConversion");
exports.BLOCK_TYPES = [
    'field',
    'group',
    'repeater',
    'unknown',
    'social',
];
exports.FIELD_TYPES = [
    'html',
    'text',
    'datetime',
    'url',
    'ad',
];
exports.FIELD_TYPES_MAP = {
    ad: 'Ad',
    datetime: 'Date',
    html: 'HTML',
    text: 'Text',
    unknown: 'Unknown',
    url: 'URL',
};
let EmailTemplateBlock = EmailTemplateBlock_1 = 
// We could possibly make use of GraphQL's TableInheritance if we need to ad some point
// @TableInheritance({
//   column: { type: 'varchar', name: 'type' },
// })
class EmailTemplateBlock extends OsmosysBaseEntity_1.OsmosysBaseEntity {
    constructor() {
        super(...arguments);
        this.isInstance = false;
        this.basicProcessing = false;
        this.fieldType = 'unknown';
        this.fieldTypes = ['text'];
        this.availableTargets = ['content'];
        this.selectedTargets = ['content'];
        // For browser:
        this.active = false;
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateVersion_1.EmailTemplateVersion]),
    typeorm_1.ManyToMany(() => EmailTemplateVersion_1.EmailTemplateVersion, version => version.blocks),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "versions", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateBlock_1]),
    typeorm_1.OneToMany(() => EmailTemplateBlock_1, block => block.instanceOf),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "instances", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplateBlock_1, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailTemplateBlock_1, block => block.instances),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "instanceOf", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean, { nullable: true }),
    typeorm_1.Column({ default: false, type: 'boolean' }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "isInstance", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateBlock_1]),
    typeorm_1.OneToMany(() => EmailTemplateBlock_1, block => block.repeatParentBlock),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "repeatChildBlocks", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplateBlock_1, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailTemplateBlock_1, block => block.repeatChildBlocks),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "repeatParentBlock", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateBlock_1]),
    typeorm_1.OneToMany(() => EmailTemplateBlock_1, block => block.repeatOf),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "repeatInstances", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplateBlock_1, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailTemplateBlock_1, block => block.repeatInstances),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "repeatOf", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [EmailTemplateBlock_1]),
    typeorm_1.OneToMany(() => EmailTemplateBlock_1, block => block.parentBlock),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "childBlocks", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => EmailTemplateBlock_1, { nullable: true }),
    typeorm_1.ManyToOne(() => EmailTemplateBlock_1, block => block.childBlocks),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "parentBlock", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false, type: 'boolean' }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "basicProcessing", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "contentStr", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({
        default: false,
        nullable: false,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "usingRichContentEditor", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Email_1.Email),
    typeorm_1.ManyToOne(() => Email_1.Email, email => email.blocks),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "email", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 'unknown' }),
    class_validator_1.IsIn(exports.BLOCK_TYPES),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "type", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: 'unknown' }),
    class_validator_1.IsIn(exports.BLOCK_TYPES),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "fieldType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String]),
    typeorm_1.Column({
        default: ['text'],
        type: 'jsonb',
    }),
    class_validator_1.IsIn(exports.FIELD_TYPES, { each: true }),
    class_validator_1.IsArray(),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlock.prototype, "fieldTypes", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String]),
    typeorm_1.Column({
        default: ['content'],
        type: 'jsonb',
    }),
    class_validator_1.IsArray(),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlock.prototype, "availableTargets", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String]),
    typeorm_1.Column({
        default: ['content'],
        type: 'jsonb',
    }),
    class_validator_1.IsArray(),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlock.prototype, "selectedTargets", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: true }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "unwrap", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "socialProvider", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "hideable", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "hidden", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "lockable", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], EmailTemplateBlock.prototype, "locked", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "fieldName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        default: 'LLL',
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "datetimeFormat", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "displayName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "groupName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "repeaterName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    typeorm_1.Column({
        default: '',
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "innerHTML", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "outerHTML", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "originalHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    tslib_1.__metadata("design:type", String)
], EmailTemplateBlock.prototype, "parsedHtml", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlock.prototype, "attrKeys", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "attrs", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'integer' }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "order", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ads_1.Ad, { nullable: true }),
    typeorm_1.ManyToOne(() => ads_1.Ad, ad => ad.blocksUsedIn),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "ad", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [Context_1.Context]),
    typeorm_1.ManyToMany(() => Context_1.Context, context => context.blocksUsedIn),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "adContexts", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentConversion_1.ContentConversion]),
    typeorm_1.ManyToMany(() => ContentConversion_1.ContentConversion, conversion => conversion.blocksUsedIn),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Array)
], EmailTemplateBlock.prototype, "conversions", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentFeed_1.ContentFeed, { nullable: true }),
    typeorm_1.ManyToOne(() => ContentFeed_1.ContentFeed, contentFeed => contentFeed.blocksUsedIn),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "contentFeed", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "contentFieldKey", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Number, { nullable: true }),
    typeorm_1.Column({ nullable: true, type: 'integer' }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "contentSlotNumber", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "contentItem", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        default: '',
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailTemplateBlock.prototype, "clientId", void 0);
EmailTemplateBlock = EmailTemplateBlock_1 = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
    // We could possibly make use of GraphQL's TableInheritance if we need to ad some point
    // @TableInheritance({
    //   column: { type: 'varchar', name: 'type' },
    // })
], EmailTemplateBlock);
exports.EmailTemplateBlock = EmailTemplateBlock;
class EmailTemplateBlockEntity extends EmailTemplateBlock {
    toString() {
        return this.name || `Email template block #${this.id}`;
    }
}
exports.EmailTemplateBlockEntity = EmailTemplateBlockEntity;
//# sourceMappingURL=EmailTemplateBlock.js.map